import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
import Typography from '../Typography';
var MIN_HEIGHT = 24;
var transition = 'all ease-out 200ms';
export var Message = styled(Typography).attrs({
  variant: 'caption12'
}).withConfig({
  displayName: "ui-kit-Message",
  componentId: "ui-kit-a9aw03"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  padding-left: 16px;\n  min-height: ", "px;\n  overflow: hidden;\n\n  &.error {\n    color: ", ";\n  }\n\n  &.disabled {\n    color: ", ";\n  }\n\n  &.grow-height-appear, &.grow-height-enter {\n    min-height: 0;\n    height: 0;\n  }\n  &.grow-height-appear-active, &.grow-height-enter-active {\n    min-height: ", "px;\n    transition: ", ";\n  }\n  &.grow-height-exit {\n    min-height: ", "px;\n  }\n  &.grow-height-exit-active {\n    min-height: 0;\n    height: 0;\n    transition: ", ";\n  }\n"], ["\n  color: ", ";\n  padding-left: 16px;\n  min-height: ", "px;\n  overflow: hidden;\n\n  &.error {\n    color: ", ";\n  }\n\n  &.disabled {\n    color: ", ";\n  }\n\n  &.grow-height-appear, &.grow-height-enter {\n    min-height: 0;\n    height: 0;\n  }\n  &.grow-height-appear-active, &.grow-height-enter-active {\n    min-height: ", "px;\n    transition: ", ";\n  }\n  &.grow-height-exit {\n    min-height: ", "px;\n  }\n  &.grow-height-exit-active {\n    min-height: 0;\n    height: 0;\n    transition: ", ";\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.palette.label.secondary;
}, MIN_HEIGHT, function (_a) {
  var theme = _a.theme;
  return theme.palette.label.negative;
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.label.inactive;
}, MIN_HEIGHT, transition, MIN_HEIGHT, transition);
export var MessageText = styled.span.withConfig({
  displayName: "ui-kit-MessageText",
  componentId: "ui-kit-7ou4ca"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: block;\n  margin-top: 8px;\n"], ["\n  display: block;\n  margin-top: 8px;\n"])));
var templateObject_1, templateObject_2;